import request from '../utils/request'

export function login(data) {
  return request.post('/api/auth/login', data, { skipErrorMessage: true })
}

export function logout() {
  return request.post('/api/auth/logout')
}

export function getMe() {
  return request.get('/api/auth/me')
}
